import { useEffect, useRef, useState } from "react";
import RightModal from "../../components/Modal/RightModal";
import SavedFilterComponent from "../../components/SavedFilters/SavedFilterComponent";
import { countNonMatchingEntries, handleDropdownClose } from "../../utils/utils";
import SystemAlertsFilterData from "./SystemAlertsFilterData";

const initialSystemAlertsFilterData = {
  search: "",
  userId: "",
  status: "",
  module: "",
  fromDate: "",
  toDate: "",
  singleDate: "",
  tab: "all",
};

const SystemAlertsFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialSystemAlertsFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain(filterData);
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const saveSearchFilterData = {
    search: filterData?.search ?? "",
    userId: filterData?.userId ?? "",
    status: filterData?.status ?? "",
    module: filterData?.module ?? "",
    fromDate: filterData?.fromDate ?? "",
    toDate: filterData?.toDate ?? "",
    singleDate: filterData?.singleDate ?? "",
    tab: filterData?.tab ?? "all",
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      search: value?.search ?? "",
      userId: value?.userId ?? "",
      status: value?.status ?? "",
      module: value?.module ?? "",
      fromDate: value?.fromDate ?? "",
      toDate: value?.toDate ?? "",
      singleDate: value?.singleDate ?? "",
      tab: value?.tab ?? "all",
    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  return (
    <div>
      <SavedFilterComponent
        from="System Alert"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialSystemAlertsFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Filter"
        desc="Enter system alert information."
        onFilter={handleFilter}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
        from="System Alert"
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <SystemAlertsFilterData
          isSidebarOpen={isSidebarOpen}
          filterData={filterData}
          onSetFilterData={onSetFilterData}
        />
      </RightModal>
    </div>
  );
};

export default SystemAlertsFilter;
export { initialSystemAlertsFilterData };
